import { useEffect } from "react";

export interface Event<P extends {} = {}> {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: Record<string, any> & P;
}

type Filter = Event | ((events: Event) => boolean);
type Callback = (event: Event) => void;

let subscribers: [filter: Filter, callback: Callback][] = [];

const subscribe = (filter: Filter, callback: Callback) => {
  if (filter === undefined || filter === null) return undefined;
  if (callback === undefined || callback === null) return undefined;

  subscribers = [...subscribers, [filter, callback]];

  return () => {
    subscribers = subscribers.filter(
      (subscriber) => subscriber[1] !== callback
    );
  };
};

export function dispatchEventBus<P extends {} = {}>(event: Event<P>) {
  subscribers.forEach(([filter, callback]) => {
    if (typeof filter === "object" && filter.type !== event.type) return;
    if (typeof filter === "function" && !filter(event)) return;

    callback(event);
  });
}

export const useEventBus = <P extends {} = {}>(
  type: Filter,
  callback: (event: Event<P>) => void,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deps: any[] = []
) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => subscribe(type, callback), deps);

  return dispatchEventBus;
};

export default useEventBus;
